import React from 'react';

const Loader = () => <div className="loader-component">Loading...</div>;

export default Loader;



// WEBPACK FOOTER //
// ./src/components/common/Loader.js